import React from 'react'
import { connect } from 'react-redux'
import addEventAction from '../actions/events/addEventAction'
import AddEventComponent from '../components/addEventDialog.component'
import getGooglePlacesAction from '../actions/events/getGooglePlacesAction'
import {EventType} from '../utils/enumUtils';
import saveTemplateDetailsUsedForAddEvent from '../actions/events/saveTemplateDetailsUsedForAddEventAction'

class AddEventContainer extends React.Component {
   render() {
      return (
         <AddEventComponent
            eventTypes = {Object.values(EventType)}
            onCreateEvent = {this.onSubmitForm.bind(this)}
            onUpdate = {this.onUpdateLocationInput.bind(this)}
            places = {this.props.places}
            open = {this.props.open}
            handleClose = {this.props.handleCloseDialog}
            userTemplates = {this.props.userTemplates}
            defaultTemplates = {this.props.defaultTemplates}
         />
      );
   }
   onSubmitForm = (eventDate, eventTitle, eventType, eventLocation, eventTemplate) => {
      this.props.saveTemplateUsed(eventTemplate);
      this.props.onSubmitForm(this.createEventObject(eventDate, eventTitle, eventType, eventLocation, eventTemplate.id), this.props.userData);
   }

   createEventObject = (eventDate, eventTitle, eventType, eventLocation, eventTemplate) => {
      return {title:eventTitle, eventType:eventType, location:eventLocation, date:eventDate, templateId:eventTemplate};
   }

   onUpdateLocationInput = (str) => {
      this.props.onUpdateLocationInput(str);
   }

}

const mapDispatchToProps = {
   onSubmitForm: addEventAction,
   onUpdateLocationInput: getGooglePlacesAction,
   saveTemplateUsed: saveTemplateDetailsUsedForAddEvent
}

const mapStateToProps = (state) => ({
   places: state.placesSuggestions.suggestions,
   userData: state.user.data,
   userTemplates: state.templates.userTemplates,
   defaultTemplates: state.templates.defaultTemplates,
})

export default connect(
     mapStateToProps,
     mapDispatchToProps
  )(AddEventContainer)



// WEBPACK FOOTER //
// ./src/containers/addEventDialog.container.js